/**
 * PATH: apps/hr/src/pages/employees/employees-list/StatCard.tsx
 * PURPOSE: Stat card component for employee directory stats row
 * WHY: Extracted from EmployeesPage.tsx to keep files under 300 lines
 */

import { cn } from '../../../lib/utils'

interface StatCardProps {
  title: string
  value: number
  icon: React.ElementType
  color: 'teal' | 'emerald' | 'blue' | 'amber' | 'red'
  onClick?: () => void
  isActive?: boolean
}

const colorMap = {
  teal: {
    bg: 'bg-teal-50 dark:bg-teal-900/20',
    icon: 'text-teal-600 dark:text-teal-400',
    border: 'border-teal-200 dark:border-teal-800',
  },
  emerald: {
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    icon: 'text-emerald-600 dark:text-emerald-400',
    border: 'border-emerald-200 dark:border-emerald-800',
  },
  blue: {
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    icon: 'text-blue-600 dark:text-blue-400',
    border: 'border-blue-200 dark:border-blue-800',
  },
  amber: {
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    icon: 'text-amber-600 dark:text-amber-400',
    border: 'border-amber-200 dark:border-amber-800',
  },
  red: {
    bg: 'bg-red-50 dark:bg-red-900/20',
    icon: 'text-red-600 dark:text-red-400',
    border: 'border-red-200 dark:border-red-800',
  },
}

export function StatCard({ title, value, icon: Icon, color, onClick, isActive }: StatCardProps) {
  const style = colorMap[color]

  return (
    <button
      onClick={onClick}
      className={cn(
        'flex items-center gap-3 p-4 rounded-xl border bg-white dark:bg-slate-900 transition-all',
        'hover:shadow-sm hover:border-slate-300 dark:hover:border-slate-700',
        isActive && `ring-2 ring-${color}-500 ${style.border}`,
        onClick && 'cursor-pointer'
      )}
    >
      <div className={cn('p-2.5 rounded-lg', style.bg)}>
        <Icon className={cn('w-5 h-5', style.icon)} />
      </div>
      <div className="text-left">
        <p className="text-2xl font-bold text-slate-900 dark:text-white">{value}</p>
        <p className="text-xs text-slate-500 dark:text-slate-400">{title}</p>
      </div>
    </button>
  )
}
